"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageStructureWriter = exports.PAGE_FORMAT_VERSION = exports.PageStructureWriteError = void 0;
exports.writePageFormatVersion = writePageFormatVersion;
exports.pageDocumentStructure = pageDocumentStructure;
exports.pageDocumentTree = pageDocumentTree;
exports.readPageStructureEntries = readPageStructureEntries;
exports.readPageDocsEntries = readPageDocsEntries;
const Y = __importStar(require("yjs"));
const fractional_indexing_1 = require("./fractional-indexing");
const page_connector_ends_1 = require("./page-connector-ends");
const page_document_maps_1 = require("./page-document-maps");
const page_format_chain_1 = require("./page-format-chain");
const page_layer_index_1 = require("./page-layer-index");
const page_structure_entry_1 = require("./page-structure-entry");
const page_structure_index_1 = require("./page-structure-index");
const page_structure_tree_1 = require("./page-structure-tree");
class PageStructureWriteError extends Error {
    constructor(message, code) {
        super(message);
        this.code = code;
        this.name = 'PageStructureWriteError';
    }
}
exports.PageStructureWriteError = PageStructureWriteError;
/** Current format, derived from the durable upgrade chain. */
exports.PAGE_FORMAT_VERSION = page_format_chain_1.PAGE_UPGRADE_STEPS[page_format_chain_1.PAGE_UPGRADE_STEPS.length - 1].to;
/** Marks a page document as written in the current format. */
function writePageFormatVersion(doc) {
    (0, page_document_maps_1.setPageFormatVersion)(doc, exports.PAGE_FORMAT_VERSION);
}
/**
 * The structure of a page that is one document: every block in part 0.
 * Parts of large pages are bound by the store that loads them.
 */
function pageDocumentStructure(doc) {
    const blocks = (0, page_document_maps_1.pagePartBlocksMap)(doc);
    const elements = (0, page_document_maps_1.pagePartElementsMap)(doc);
    return {
        createPart: partId => {
            if (partId !== page_document_maps_1.PAGE_DOCUMENT_PART_ID)
                throw new PageStructureWriteError(`Cannot create part ${partId} in a single page document`);
        },
        loadedPartIds: () => [page_document_maps_1.PAGE_DOCUMENT_PART_ID],
        head: doc,
        partStructure: partId => partId === page_document_maps_1.PAGE_DOCUMENT_PART_ID ? (0, page_document_maps_1.pageStructureMap)(doc) : null,
        partBlocks: partId => (partId === page_document_maps_1.PAGE_DOCUMENT_PART_ID ? blocks : null),
        partElements: partId => partId === page_document_maps_1.PAGE_DOCUMENT_PART_ID ? elements : null,
    };
}
/** The tree of a page document, from its structure map. */
function pageDocumentTree(doc) {
    return (0, page_structure_tree_1.derivePageTree)(readPageStructureEntries((0, page_document_maps_1.pageStructureMap)(doc), page_document_maps_1.PAGE_DOCUMENT_PART_ID));
}
/** The entries of a structure map, decoded. */
function readPageStructureEntries(structure, partId) {
    return new Map([...structure.entries()].map(([id, value]) => [
        id,
        (0, page_structure_entry_1.decodePageStructureEntry)(value, partId),
    ]));
}
/** The entries of every loaded part, read through the same decoder. */
function readPageDocsEntries(docs) {
    const entries = new Map();
    for (const partId of docs.loadedPartIds()) {
        const structure = docs.partStructure(partId);
        if (!structure)
            throw new PageStructureWriteError(`Page part ${partId} is not loaded`);
        for (const [id, entry] of readPageStructureEntries(structure, partId))
            entries.set(id, entry);
    }
    return entries;
}
/**
 * The one writer of page structure, for the BlockSuite store and the server
 * alike: inserting, moving and deleting blocks and canvas elements write
 * structure entries and their fields in their part, never a child list.
 * Moving a block or reordering an element writes exactly its own entry;
 * group and frame membership is the entry's g. Callers run it inside their
 * transaction.
 * A writer of a loaded page reads through the page's one subscribed index;
 * a writer without an explicit index uses the same map's shared index.
 */
class PageStructureWriter {
    constructor(docs, shared) {
        this.docs = docs;
        this.shared = shared;
        if (shared && shared.structure !== (0, page_document_maps_1.pageStructureMap)(docs.head)) {
            throw new PageStructureWriteError('The index belongs to another structure map');
        }
    }
    entries() {
        return this.view().entries();
    }
    canvasLayerBounds() {
        return this.view().canvasLayerBounds();
    }
    tree() {
        return this.view().tree();
    }
    insertBlock(input) {
        const index = this.view();
        this.requirePlaceable(index, input.id, input.parentId, input.partId);
        const block = new Y.Map();
        this.requirePart(input.partId).set(input.id, block);
        block.set('sys:id', input.id);
        block.set('sys:flavour', input.flavour);
        block.set('sys:version', input.version);
        for (const [key, value] of Object.entries(input.props)) {
            if (value !== undefined)
                block.set(`prop:${key}`, value);
        }
        this.place(index, input);
    }
    /**
     * Places a block whose fields its part already holds, as builders that
     * assemble nested values write them: one entry under `parentId`.
     */
    placeBlock(input) {
        const index = this.view();
        this.requirePlaceable(index, input.id, input.parentId, input.partId);
        this.place(index, input);
    }
    /**
     * Keeps a block whose fields part 0 holds on the page without a place in
     * its tree: one entry under PAGE_TREE_UNPLACED_ID. A block with a live
     * entry keeps it.
     */
    keepUnplaced(id) {
        const index = this.view();
        const entry = index.entries().get(id);
        if (entry && entry.p !== page_structure_tree_1.PAGE_TREE_DELETED_ID)
            return;
        if (entry && entry.s !== page_document_maps_1.PAGE_DOCUMENT_PART_ID)
            throw new PageStructureWriteError(`Block ${id} cannot change part`);
        const flavour = this.requirePart(page_document_maps_1.PAGE_DOCUMENT_PART_ID)
            .get(id)
            ?.get('sys:flavour');
        if (typeof flavour !== 'string')
            throw new PageStructureWriteError(`Block ${id} has no fields in part ${page_document_maps_1.PAGE_DOCUMENT_PART_ID}`);
        const [order] = orderKeysAt(index.entries(), [], 0, 1);
        this.write(index, id, {
            k: flavour,
            p: page_structure_tree_1.PAGE_TREE_UNPLACED_ID,
            o: order,
            s: page_document_maps_1.PAGE_DOCUMENT_PART_ID,
        });
    }
    place(index, input) {
        const entries = index.entries();
        const flavour = this.requirePart(input.partId)
            .get(input.id)
            ?.get('sys:flavour');
        if (typeof flavour !== 'string') {
            throw new PageStructureWriteError(`Block ${input.id} has no fields in part ${input.partId}`);
        }
        // The root starts a page: the page is written in the current format.
        if (input.parentId === null) {
            writePageFormatVersion(this.docs.head);
        }
        const siblings = input.parentId === null ? [] : index.childrenOf(input.parentId);
        const at = clampIndex(input.index, siblings.length);
        const [order] = orderKeysAt(entries, siblings, at, 1);
        const layer = this.blockLayer(index, input.id, flavour, input.parentId, input.partId);
        this.write(index, input.id, {
            k: flavour,
            p: input.parentId,
            o: order,
            s: input.partId,
            ...(layer === undefined ? {} : { l: layer }),
        });
    }
    blockLayer(index, id, flavour, parentId, partId) {
        const entries = index.entries();
        const parentKind = parentId === null ? undefined : entries.get(parentId)?.k;
        if (!(0, page_layer_index_1.pageBlockInCanvasLayer)(flavour, parentKind))
            return undefined;
        const fields = this.requirePart(partId).get(id);
        if (!fields)
            throw new PageStructureWriteError(`Block ${id} has no fields in part ${partId}`);
        const usesLayer = (0, page_layer_index_1.pageBlockUsesLayer)(id, flavour, parentKind, {
            managedBy: fields.get('prop:managedBy'),
            visible: fields.get('prop:visible'),
            xywh: fields.get('prop:xywh'),
        });
        let layer = usesLayer ? undefined : null;
        if (usesLayer) {
            const value = fields.get('prop:index');
            if (value === undefined) {
                const top = index.canvasLayerBounds().last;
                layer = (0, fractional_indexing_1.generateFractionalIndexingKeyBetween)(top, null);
            }
            else {
                if (!(0, page_structure_entry_1.isFractionalIndex)(value))
                    throw new PageStructureWriteError('Invalid block layer index');
                layer = value;
            }
            fields.set('prop:index', layer);
        }
        return layer;
    }
    /**
     * Places a canvas element whose fields its part already holds: one entry
     * on its surface with the element's layer index as order.
     */
    placeElement(input) {
        const index = this.view();
        const entries = index.entries();
        const entry = entries.get(input.id);
        if (entry && entry.p !== page_structure_tree_1.PAGE_TREE_DELETED_ID) {
            throw new PageStructureWriteError(`Element ${input.id} already exists`);
        }
        this.requireParent(index, input.surfaceId);
        const fields = this.requireElementPart(input.partId).get(input.id);
        const type = fields?.get('type');
        if (typeof type !== 'string' || !(0, page_structure_entry_1.isPageElementKind)(type)) {
            throw new PageStructureWriteError(`Element ${input.id} has no fields in part ${input.partId}`);
        }
        this.write(index, input.id, {
            k: type,
            p: input.surfaceId,
            o: input.order,
            s: input.partId,
            ...(type === page_structure_entry_1.PAGE_CONNECTOR_KIND
                ? { c: (0, page_connector_ends_1.readPageConnectorEnds)(input.id, fields) }
                : {}),
        });
    }
    /** Repeats the ends of connector `id` from its fields in its entry. */
    syncConnectorEnds(id) {
        const index = this.view();
        const entry = this.requireEntry(index, id);
        const fields = this.requireElementPart(entry.s).get(id);
        if (entry.k !== page_structure_entry_1.PAGE_CONNECTOR_KIND || !fields)
            throw new PageStructureWriteError(`Element ${id} is no loaded connector`);
        const c = (0, page_connector_ends_1.readPageConnectorEnds)(id, fields);
        if (!(0, page_structure_entry_1.samePageConnectorEnds)(entry.c, c))
            this.write(index, id, { ...entry, c });
    }
    /** Layer index of a canvas element. */
    setOrder(id, order) {
        const index = this.view();
        const entry = this.requireEntry(index, id);
        if (entry.o !== order)
            this.write(index, id, { ...entry, o: order });
    }
    /**
     * Moves blocks, in the given order, under `parentId`: before or after
     * `targetSibling`, or to the end without one. Writes one entry per block.
     */
    moveBlocks(ids, parentId, targetSibling = null, beforeSibling = true) {
        const index = this.view();
        const entries = index.entries();
        this.requireParent(index, parentId);
        const seen = new Set();
        for (let ancestor = parentId; ancestor !== null && !seen.has(ancestor); ancestor = entries.get(ancestor)?.p ?? null) {
            if (ids.includes(ancestor)) {
                throw new PageStructureWriteError(`Block ${ancestor} cannot move into its own subtree`);
            }
            seen.add(ancestor);
        }
        const siblings = index.childrenOf(parentId).filter(id => !ids.includes(id));
        const target = targetSibling === null ? -1 : siblings.indexOf(targetSibling);
        const at = target === -1 ? siblings.length : beforeSibling ? target : target + 1;
        const orders = orderKeysAt(entries, siblings, at, ids.length);
        const moved = ids.map(id => {
            const entry = entries.get(id);
            if (!entry) {
                throw new PageStructureWriteError(`Block ${id} does not exist`);
            }
            return entry;
        });
        ids.forEach((id, at) => {
            // A deleted block moved back into the page is no longer deleted.
            const { l: _oldLayer, d: _deletedAt, ...entry } = moved[at];
            const layer = this.blockLayer(index, id, entry.k, parentId, entry.s);
            this.write(index, id, {
                ...entry,
                p: parentId,
                o: orders[at],
                ...(layer === undefined ? {} : { l: layer }),
            });
        });
    }
    /**
     * Marks a block deleted, retaining its fields. Its children go with it
     * (the default) or move to `bringChildrenTo`: at the block's place when
     * that is its parent, else to the end.
     */
    deleteBlock(id, options = {}) {
        const index = this.view();
        const entries = index.entries();
        const entry = entries.get(id);
        if (!entry)
            return;
        const children = [...index.childrenOf(id)];
        const { bringChildrenTo } = options;
        if (bringChildrenTo !== undefined && children.length > 0) {
            this.requireParent(index, bringChildrenTo);
            const siblings = index.childrenOf(bringChildrenTo);
            const withoutBlock = siblings.filter(sibling => sibling !== id);
            const at = bringChildrenTo === entry.p
                ? siblings.indexOf(id)
                : withoutBlock.length;
            const orders = orderKeysAt(entries, withoutBlock, at, children.length);
            const moved = children.map(child => entries.get(child));
            children.forEach((child, at) => {
                const { l: _oldLayer, ...entry } = moved[at];
                const layer = this.blockLayer(index, child, entry.k, bringChildrenTo, entry.s);
                this.write(index, child, {
                    ...entry,
                    p: bringChildrenTo,
                    o: orders[at],
                    ...(layer === undefined ? {} : { l: layer }),
                });
            });
            this.remove(index, id, entry);
            return;
        }
        const subtree = [id];
        const seen = new Set(subtree);
        // The iteration also visits the children pushed on the way.
        for (const member of subtree) {
            for (const child of [
                ...index.childrenOf(member),
                ...index.elementsOf(member),
            ]) {
                if (!seen.has(child)) {
                    seen.add(child);
                    subtree.push(child);
                }
            }
        }
        const removed = subtree.map(member => entries.get(member));
        subtree.forEach((member, at) => this.remove(index, member, removed[at]));
    }
    /**
     * Marks one block or canvas element deleted, retaining its fields;
     * one never placed has its fields removed from part 0. Children are the caller's to
     * remove as well; children left behind are recovered.
     */
    removeBlock(id) {
        const index = this.view();
        const entry = index.entries().get(id);
        if (entry === undefined) {
            this.docs.partBlocks(page_document_maps_1.PAGE_DOCUMENT_PART_ID)?.delete(id);
            this.docs.partElements(page_document_maps_1.PAGE_DOCUMENT_PART_ID)?.delete(id);
            return;
        }
        this.remove(index, id, entry);
    }
    /** Group or frame membership; undefined leaves every group. */
    setGroup(id, group) {
        const index = this.view();
        if (group !== undefined)
            this.requireParent(index, group);
        const entry = this.requireEntry(index, id);
        const { g: _previous, ...rest } = entry;
        this.write(index, id, group === undefined ? rest : { ...rest, g: group });
    }
    /**
     * Writes layer-related fields and their head projection through one path.
     * An undefined value removes the field. The head is written only when the
     * layer of the block changes: a move (xywh to xywh) writes the field alone.
     */
    setLayerProperties(id, props) {
        const index = this.view();
        const entry = this.requireEntry(index, id);
        const fields = this.requirePart(entry.s).get(id);
        const parentKind = entry.p === null ? undefined : index.entries().get(entry.p)?.k;
        if (!fields || !(0, page_layer_index_1.pageBlockInCanvasLayer)(entry.k, parentKind))
            throw new PageStructureWriteError(`Block ${id} has no canvas layer`);
        const read = (key) => Object.prototype.hasOwnProperty.call(props, key)
            ? props[key]
            : fields.get('prop:' + key);
        let value = read('index');
        const hidden = !(0, page_layer_index_1.pageBlockUsesLayer)(id, entry.k, parentKind, {
            managedBy: read('managedBy'),
            visible: read('visible'),
            xywh: read('xywh'),
        });
        if (!hidden && value === undefined && entry.l === null)
            value = (0, fractional_indexing_1.generateFractionalIndexingKeyBetween)(index.canvasLayerBounds().last, null);
        if (!hidden && !(0, page_structure_entry_1.isFractionalIndex)(value))
            throw new PageStructureWriteError('Missing or invalid block layer index');
        const layer = hidden ? null : value;
        this.docs.head.transact(() => fields.doc.transact(() => {
            for (const [key, value] of Object.entries(props)) {
                if (key === 'index')
                    continue;
                if (value === undefined)
                    fields.delete('prop:' + key);
                else
                    fields.set('prop:' + key, value);
            }
            const stored = layer ?? read('index');
            if (stored === undefined) {
                if (fields.has('prop:index'))
                    fields.delete('prop:index');
            }
            else if (stored !== fields.get('prop:index'))
                fields.set('prop:index', stored);
            if (layer !== entry.l)
                this.write(index, id, { ...entry, l: layer });
        }));
    }
    setLayer(id, layer) {
        this.setLayerProperties(id, { index: layer });
    }
    /** Presentation index of a frame; undefined removes it. */
    setPresentationIndex(id, pi) {
        const index = this.view();
        const entry = this.requireEntry(index, id);
        const { pi: _previous, ...rest } = entry;
        this.write(index, id, pi === undefined ? rest : { ...rest, pi });
    }
    view() {
        const index = this.shared ?? (0, page_structure_index_1.pageStructureIndexOf)((0, page_document_maps_1.pageStructureMap)(this.docs.head));
        for (const partId of this.docs.loadedPartIds())
            index.bindPart(partId, this.requireStructure(partId));
        return index;
    }
    requirePlaceable(index, id, parentId, partId) {
        const entries = index.entries();
        const entry = entries.get(id);
        // An unplaced block takes its place in the tree.
        if (entry &&
            entry.p !== page_structure_tree_1.PAGE_TREE_DELETED_ID &&
            entry.p !== page_structure_tree_1.PAGE_TREE_UNPLACED_ID) {
            throw new PageStructureWriteError(`Block ${id} already exists`);
        }
        if (entry && entry.s !== partId)
            throw new PageStructureWriteError(`Block ${id} cannot change part`);
        if (parentId !== null)
            this.requireParent(index, parentId);
    }
    requireParent(index, id) {
        if (!(0, page_structure_tree_1.isPageTreeEntry)(this.requireEntry(index, id))) {
            throw new PageStructureWriteError(`Block ${id} does not exist`);
        }
    }
    requireEntry(index, id) {
        const entry = index.entries().get(id);
        if (entry === undefined) {
            throw new PageStructureWriteError(`Block ${id} does not exist`);
        }
        return entry;
    }
    requireStructure(partId) {
        const structure = this.docs.partStructure(partId);
        if (!structure)
            throw new PageStructureWriteError(`Page part ${partId} is not loaded`);
        return structure;
    }
    requirePart(partId) {
        this.requireStructure(partId);
        const blocks = this.docs.partBlocks(partId);
        if (!blocks) {
            throw new PageStructureWriteError(`Page part ${partId} is not loaded`);
        }
        return blocks;
    }
    requireElementPart(partId) {
        this.requireStructure(partId);
        const elements = this.docs.partElements(partId);
        if (!elements) {
            throw new PageStructureWriteError(`Page part ${partId} is not loaded`);
        }
        return elements;
    }
    write(index, id, entry) {
        const previous = index.entries().get(id);
        if (previous && previous.s !== entry.s)
            throw new PageStructureWriteError(`Block ${id} cannot change part`);
        this.requireStructure(entry.s).set(id, (0, page_structure_entry_1.encodePageStructureEntry)(entry));
        index.written(id, entry);
    }
    remove(index, id, entry) {
        const { g: _group, pi: _presentation, ...rest } = entry;
        this.write(index, id, {
            ...rest,
            p: page_structure_tree_1.PAGE_TREE_DELETED_ID,
            d: String(Date.now()),
        });
    }
}
exports.PageStructureWriter = PageStructureWriter;
function clampIndex(index, length) {
    return index === undefined || index > length ? length : Math.max(0, index);
}
/**
 * `count` increasing order keys for the place `at` among `siblings`. Equal
 * keys of concurrent writes are skipped to the next greater one, so the new
 * keys sort after every sibling before the place.
 */
function orderKeysAt(entries, siblings, at, count) {
    const orderOf = (index) => entries.get(siblings[index]).o;
    const lower = at > 0 ? orderOf(at - 1) : null;
    let upperIndex = at;
    while (upperIndex < siblings.length &&
        lower !== null &&
        orderOf(upperIndex) <= lower) {
        upperIndex++;
    }
    const upper = upperIndex < siblings.length ? orderOf(upperIndex) : null;
    const keys = [];
    let previous = lower;
    for (let index = 0; index < count; index++) {
        const key = (0, fractional_indexing_1.generateFractionalIndexingKeyBetween)(previous, upper);
        keys.push(key);
        previous = key;
    }
    return keys;
}
